import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthInterceptorHelperService } from '@sameta/shared';
import { AuthService } from './services/auth.service';

/**
 * Combined interceptor that handles both:
 * 1. Adding Authorization header to requests
 * 2. Handling AUTHORIZATION_EXPIRED errors with token refresh
 *
 * This mimics the behavior of sameta-fe-jobs' functional interceptor
 */
@Injectable()
export class CombinedAuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly authInterceptorHelper: AuthInterceptorHelperService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Step 1: Add Authorization header if token exists and header not already present
    let authReq = request;
    const token = localStorage.getItem('session');

    if (token && !request.headers.has('Authorization') && !request.headers.has('Token')) {
      authReq = request.clone({
        setHeaders: {
          Authorization: token
        }
      });
    }

    // Step 2: Handle the request and catch errors for token refresh
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Use the shared helper service to handle AUTHORIZATION_EXPIRED
        return this.authInterceptorHelper.handleAuthorizationExpired(
          error,
          authReq,
          next,
          this.authService,
          '/login' // redirect to login page for sameta-fe
        );
      })
    );
  }
}
